import { render, staticRenderFns } from "./cancelMergePools.vue?vue&type=template&id=6dd783f2&scoped=true"
import script from "./cancelMergePools.vue?vue&type=script&lang=ts"
export * from "./cancelMergePools.vue?vue&type=script&lang=ts"
import style0 from "./cancelMergePools.vue?vue&type=style&index=0&id=6dd783f2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd783f2",
  null
  
)

export default component.exports